module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/ch3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("July")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Having survived that first weekend, I felt a little more confident. As the days passed, Art and I began to form a routine. We met for breakfast every morning in the hospital cafeteria. Technically, only residents who had been on call the night before, or who had started work before 6:00 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")]), _vm._v(", were entitled to free breakfast, but when Art saw me reach for my wallet at the checkout line the first day he said, “Pay no attention to that bullshit. When you work as hard as we do, breakfast is free.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The ortho residents always sat together, often taking up two or three long tables in the cafeteria. Although we would occasionally let medical students sit with us, we never allowed fleas.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was sitting at breakfast one morning listening to the senior residents argue whether a staple from an old upper tibial osteotomy had to be removed before doing a total knee replacement. I never took part in these conversations. I was barely able to understand what they were talking about.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Down the table someone was reading the morning paper. Jack Manning, on call from the night before, was resting his head on his hand, staring bleary-eyed into space, a cold cup of coffee in front of him. Beepers were going off. Guys were hurrying away, leaving their breakfasts half-eaten. Other guys were arriving and taking their place. Several conversations were taking place at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not kidding; she kept waving her cigarette holder at Dr. Hale, telling him there was a battalion of tiny Iranian devils with poisoned pitchforks that waited ’til she fell asleep so they could start stabbing her in the groin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I tried to fix the lateral side first but I just couldn’t reduce it. So I had to open the medial side, repair the ligament, and then go back and plate the lateral side. The damn thing took almost two hours.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Art, who wasn’t interested in shoptalk, made a remark about a skirt he saw on a woman at the Depot House, Rochester’s only singles bar. “Two more inches and I think I could have seen the dark side of the moon,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Breakfast was Art’s time to regale us with stories of his latest conquests. Handsome, witty, an excellent athlete, and an incredibly charming ladies’ man, Art was a legend at Mayo. He always had some beautiful woman at his side. Although reasonably skilled as a surgeon, his work tended at times to be careless. He made no secret that his main interests were anatomic not orthopedic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m only human,” he said with a sigh of helplessness. “I couldn’t fight her off one more minute. Against my better judgment I finally had to give myself to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Against your better judgment, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Even the just man falls seven times a day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You wish.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Art and I helped Mrs. Schmidt onto the operating table. After the anesthesiologists had put her to sleep, we wrapped a tourniquet around her upper thigh, prepped and draped her, and then sent for Dr. Harding. I was excited. This would be the first total knee replacement I had ever seen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Big John came down from the staff lounge, scrubbed in, slapped his hands together, and approached the table. He took the patient’s knee in his huge hands and bent it up and down several times. He palpated both sides of the knee, then held out his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Scalpel,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The scrub nurse slapped the scalpel in his hand. Before I realized what was happening, Big John had run his hand down the front of the knee, and had sliced it wide open. Layers of fat spread to either side, and despite the tourniquet, blood began to ooze from several spots.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Within sixty seconds he had opened the capsule, everted the kneecap, and exposed the joint. I could see the worn and frayed cartilage, the spurs, and the bare bone where the cartilage had eroded. Periodically Dr. Harding would cut away a glob of fat and drop it in the kick bucket next to the table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I had pictured surgery as a series of delicate maneuvers performed with a scalpel held gently between thumb and forefinger. This procedure seemed like bloody, rapid-fire chaos. “Slash and bash,” Art had called it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he finished exposing the joint, Dr. Harding picked up a power saw from the nurse’s table and began to saw off the end of the femur. The piercing whine of the saw was unsettling, especially in light of my preconceived notions of the delicate nature of surgery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s got a lot of medial compartmental erosion,” John said after he finished the femoral cut. “That means we’re going to have to angle our tibial cut "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" way.” He grunted as he rammed a retractor into the other side of the knee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here. Hold this damn thing,” he said, turning to me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I grabbed the retractor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t be afraid of it. It won’t bite you,” John said. “Pull hard on it. I have to be able to see the entire plateau before I make the cut.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took the saw from the nurse, leaned to his right for better leverage, and sawed off the top of the tibia. Then he flipped over the patella and sawed off the underside of it, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Art irrigated the wound with antibiotic solution, Big John turned to the scrub nurse, instructing her on what prostheses he would use. I, meanwhile, stared in fascination at the sight in front of me. Our patient’s knee was filleted open. Sawed-off chunks of bone lay scattered about the field. I tried to act nonchalant, as though I were used to being surrounded by mutilated body parts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(Yeah, ho-hum. Just another routine dismemberment. A femur here, a kneecap there. No big deal. It’s all in a day’s work.)")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Art was irrigating the wound, and fluid was spilling over the side of the knee. “Hey, numb nuts,” he whispered. “Suck, will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I grabbed the suction and a lap sponge and began cleaning up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("John finished selecting the prosthetic components he would use. The circulating nurse opened them and dropped them on the sterile back table. John then turned to us.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now,” he said, “the fun part.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("(So, what was the dismemberment—the boring part?)")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("First he held the components against the femur and tibia, assessing the fit. He took the saw and shaved a little more off one side of the tibia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right,” he said, turning to the scrub nurse, “you can mix.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse shook some white powder from a plastic pouch into a dish in front of her. Then she broke open a brown vial of a strong-smelling liquid and began mixing it with the powder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Powder? Liquid? What the hell was this? Was Big John going to start sprinkling this stuff over the patient like some shaman? I half expected him to start chanting incantations. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unga gagunga")]), _vm._v(". Was he going to promise her total consciousness on her deathbed, too? Well, at least she’d have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" going for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Three minutes later the nurse told John she was ready. He took the white, creamy mixture (that I later learned was bone cement) and began applying it to the end of the bone and the undersurface of each prosthesis. He then fit the prosthesis to the bone, took a large mallet, and began banging away on it, impacting it into place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What a strange world: blood, bone, body parts, saws, hammers. How totally different from what I had expected. We seemed more like carpenters on a construction site than surgeons in an operating room. And yet I found it incredibly exciting, and was disappointed that to everyone else it seemed so routine. I wanted them to feel as I did, that this was something extraordinary, something reverential. We had opened a human body, cut away parts of it, discarded them, put in new ones, and then closed everything up again. And in a day or two this person would be walking, her pain gone. It was incredible. I wanted to keep this awe and fascination forever. I didn’t want it to ever become routine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At 5:00 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("P.M.")]), _vm._v(", we finished our last case. I had been on call the night before, and although I had slept a few hours, the long day in the OR had worn me out. I sagged against the wall in the residents’ locker room and called my wife for a ride home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fifteen minutes later Patti pulled up to the back entrance of Methodist Hospital. Eileen, in her car seat, was chewing on a fistful of animal crackers. She waved her free hand and garbled her hello.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I leaned in the back window, picked out a clean spot on her forehead, and kissed her. Then Patti slid over and I got behind the wheel. As I swung out of the lot, Patti laid her left hand on my forearm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Miss me?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I turned to her and nodded, a sleepy smile on my face. “I always miss you.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Patti was excited for me. She was a nurse, and she spoke the language. For the first few months of my residency, Patti probably knew more orthopedics than I did. She loved hearing about my work. Most young couples talk about movies or books or sports. We talked orthopedics. Constantly. In the car, over dinner, feeding the baby, doing dishes, in bed at night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s amazing how much that guy bled,” I said one night as I turned out the lights and reached for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s where Patti drew the line. “Are we going to talk about bleeding,” she said, pushing my hand away, “or are we going to—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bleeding? Who cares about bleeding? Why would you want to talk about bleeding at a moment like this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On Friday nights those of us who weren’t on call would meet, with our wives, at Tinkler’s on Second Street. There would be beers, laughter—and more shoptalk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not kidding you,” Frank Wales was saying one night. “This feller was so liquored up he didn’t even know his finger was missing. By the time the hand guys got him to the OR it was five "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")]), _vm._v(" I was just getting into bed when some nurse up on Seven called me to see one of Satterfield’s patients, who claimed Russian spies were hiding under her bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She may be on to something,” Bill Chapin said as he filled our glasses from the pitcher. “I’ve been up on Seven, and the place is crawling with Commies.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re a big help. I should have had the nurses call you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No thanks. I was busy communicating with Martians through the fillings in my teeth. So what did you do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I checked under her gol-dang bed and told her no one was there. Then she told me "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" was a Russian spy. That’s when I got a psych consult.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For you or her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“At that point I reckon I needed one as bad as she did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Patti, Alice Chapin, and Linda Wales were on one side of the table chatting away, casting an occasional disapproving glance at Frank, Bill, and me if our stories got too graphic or our jokes too crude.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where in the hell is Manning tonight?” Frank asked. “On call?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bill shook his head. “No, he and Sue are at a fondue party.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A fon—what in the Sam Hill is a fondoo party?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s a party where everyone fondles everyone else,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is not,” Patti said. Like most women she could carry on three conversations and still know what is going on at all the tables around her. “A fondue party is where people gather to taste fondue. Fondue is a sort of melted cheese.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frank looked perplexed. “Why in the hell would they want to do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s a party, Frank,” she said. “It’s just a way to get together with your friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So’s this, and I don’t need no neighbors pouring melted cheese over me neither.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Depends on the neighbor,” Bill said. “Now there are a couple of fine ladies in our neighborhood I wish would pour melted cheese over me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who?” Alice said. “Leslie Wilson? As if she’d have you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, yeah? Well, she already called and invited me to a Mazola party.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The wives laughed uproariously. “Can you see it?” Alice said, holding her sides. “Bill at a Mazola party!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Beats melted cheese is all I can say,” Frank said.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Dr. Jonathan J. Wilhelm took a bite of his pancake, delicately wiped the corner of his mouth with his napkin, and then jerked his thumb at me. “Jesus Christ, who is this guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wilhelm was a senior resident who liked the sound of his own voice. He tended to dominate all conversations, constantly interjecting his opinion on everything. It was well known that he expected to be asked to stay on staff at Mayo when he finished his residency.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The topic at breakfast that morning was shoulder dislocations and, as usual, I just sat there and listened. They had been talking about an operation called a “Bristow.” I asked Art what a Bristow was. Wilhelm couldn’t believe it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t tell me this guy is an ortho resident,” he said to everyone at the table. He turned to me. “Are you a medical student or a flea?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m the junior resident on Harding’s service.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You")]), _vm._v(" are an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ortho")]), _vm._v(" resident?” He threw up his hands in disgust.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was too intimidated, too shamefully aware of my own ignorance to defend myself. To his credit, Art stood up for me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Back off, Wilhelm. He’s all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right? An ortho resident who never heard of a Bristow? Jesus Christ.” He shook his head and went back to his pancakes. I was just starting to sink back into a relieved anonymity when he turned to me and said, “Did you know the hip bone is connected to the thigh bone?” He was greatly amused by this witticism and looked around the table, encouraging everyone else to join his laughter. One or two did before Art once again told Wilhelm to knock it off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Whatever you say, Art,” Wilhelm said as the laughter subsided. “After all, you’re the one who’s stuck with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There is only so much shit one can eat. Art saw the look in my eyes and grabbed me by the elbow. “Come on, Cassius,” he said. “We gotta make rounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wilhelm by then had forgotten me. He was lecturing the rest of the table on the histology of ligament healing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Forget it,” Art said, steering me away from the table. “The guy is a jerk. If the Clinic asks him to stay on staff they’re out of their minds.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The Mayo work week was divided into surgery days and clinic days. We either operated all day, or we saw patients in the clinic all day. On surgery days I was the second assistant on all cases. Art would get to operate once in a while, but I did nothing more than hold retractors and write post-op orders. On clinic days I tagged along behind Art and Dr. Harding as they saw patients.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After finishing rounds one morning, Art and I made our way to the fourteenth floor of the Mayo Building. We squeezed in the door of the orthopedic residents’ lounge just as three other guys were coming out. Inside, six or seven residents were reading mail, dropping off briefcases, or talking. In the corner, in an old, overstuffed armchair, a resident in a rumpled blue sport coat was sound asleep, his head lolled to the right, his mouth slightly open. A row of mail slots lined the wall on our left. Above the mail slots was a bulletin board crammed with notices from Dr. Benjamin J. (“BJ”) Burke, the director of the residency program:")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_vm._v("—“All residents are reminded that the dress code—coat and tie—remains in force on weekends. No resident is to make rounds unless in coat and tie.”")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_vm._v("—“The annual Orthopedic In-training Exam will be held on Saturday, September 23. All residents are required to take this exam.”")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_vm._v("—“Saturday morning conference is MANDATORY for all residents. NO EXCUSES!!”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("As head of the residency program, Dr. Burke ran our lives. He was our lord and master, the engineer at the throttle of the train to salvation. We could not get through the program, we could not become orthopedic surgeons, unless BJ gave his blessing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Be careful of BJ,” Art warned me. “Every year, one or two guys get on his bad side and he makes life miserable for them. He picks on them at conferences, stops them in the hall if their tie is crooked, everything. Don’t piss that man off or your ass is grass.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I planned to stay as far from Dr. Burke as I could. If he found out how ignorant I was, he would bury me. “Do your job. Keep your mouth shut. Don’t draw any attention to yourself” was the message I kept repeating to myself. I was, and planned to remain, the Invisible Resident.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Being the Invisible Resident on Dr. Harding’s service was easy. Within a week, he must have realized how far behind I was. For that reason he did the kindest thing he could have done: he ignored me. When we made rounds it was always Art to whom he spoke. In the OR it was always Art whom he allowed to operate. I wasn’t even sure if Big John knew my name—but I didn’t blame him. I needed to get myself to a certain level before it was worth his while to teach me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, I had plenty of impetus to learn. It terrified me to realize my decisions could literally kill or cripple someone. Sure, there were safeguards. No one was going to hand me a scalpel on my first day. But someday my turn would come—and I’d better be ready.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I studied harder than I had ever studied before—partly because I was ashamed of my ignorance, partly because I realized that patients’ health and lives would soon depend on me, and partly because I actually liked this stuff. I was falling in love with orthopedics.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Every night I took out the index cards upon which I had jotted down questions and notes. I went over them one by one, often waking at 2:00 or 3:00 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")]), _vm._v(", my head slumped forward on the desk, drool staining the page I had been reading. I would stagger to bed and curl up next to Patti for a few hours. The next morning I would start all over again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Art was always a bit impatient with my constant barrage of questions. He knew if he encouraged me I would pepper him with questions all day long. But he did one thing that helped me immensely: he dumped responsibility on me. He constantly took off and left me to handle things on the service. “Heck of a deal!” was his comment on almost everything.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We were in the locker room changing into our street clothes when Art told me one of Big John’s claims to fame was that he had memorized a long narrative poem about an English boy named Little Albert. An hour later, when we finished rounds, Art nudged me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Say, Dr. Harding, I don’t think Mike here has heard "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Little Albert")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah,” Big John said with a smile. “You’ve never heard "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Little Albert?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I confessed I had not.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He put his huge left hand on my shoulder and broke into a poem about Little Albert and his encounter with a lion. He recited it for us in a cockney accent as we stood outside the elevator on the seventh floor. His big face lit up as he glanced back and forth, eyes dancing, arms gesturing, as he related the comical story of a little boy’s ill-fated visit to the zoo. The story ends with Little Albert getting eaten by the lion, after which his father philosophically observes that “what can’t be helped must be endured.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I would think of that line often during the next four years.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I had six days left on Harding’s service when Marvella, his secretary, called me. Prince Saleb had invited Dr. Harding, Art, and me to dinner in his suite at the Kahler Hotel. We had done a knee replacement on the prince two weeks before, and this apparently was his way of thanking us.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wives, too?” I asked. Patti could use a night out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, Doctor, just the three of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Uh-oh. Pat wasn’t going to be thrilled. She would have to stay home and eat Hamburger Helper with Eileen while I dined in a penthouse suite with a prince. I was already figuring out how to break the news to her when I asked Marvella, “When is the dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wednesday night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I groaned. “Oh, no, not Wednesday. I’m on call.” I paused, waiting for her to say, “No problem. I’ll just check with the prince and see if we can make it another night.” Instead she said, “That’s a shame.” Princes and department heads don’t rearrange their schedules to accommodate junior residents.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Art told me later that the hotel catered the entire affair. It was a dinner of candlelight, crystal, and silver, served in the prince’s suite on the top floor of the Kahler. The prince had rented out the entire floor for the month he stayed in Rochester.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I asked Art later if the prince had expressed any regret that I was unable to attend the dinner. Art laughed. I suppose there must be a Kuwaiti equivalent for a junior resident, and whatever it was, no prince was going to bother with him. I wondered if my declining the invitation might even have been regarded as a snub on my part. Perhaps they thought it inconceivable that Dr. Harding’s “slave” would have the temerity to refuse them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Art told me the meal went reasonably well. They ate in silence. The prince’s translator stood unobtrusively several feet behind him. There was limited call for his services. The Kuwaitis were intimidated by Harding’s Western aplomb, while Art and John were intimidated by the Kuwaitis’ wealth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When they were leaving, John thanked their host for a fine evening. The prince shook his hand and then spoke the only words of English any of us had ever heard from him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am very much to thank you for your generous goodness on me,” he said, bowing gravely. He reached over to a table upon which three small boxes were resting. He handed one to John and the other to Art.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That last box,” Art told me the next day as he stretched out his arm to show me his new Rolex watch, “was yours. Pity you couldn’t make the dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He gave you a Rolex? You son of a bitch.” I wadded my surgeon’s cap into a ball and threw it in the corner. “While you and Big John were eating lobster and frog legs, I had four consults, a wrist fracture, and a pussed-out knee in a drug addict.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Perhaps it’s just as well,” Art said. “After all, I would hate to see you become overly concerned with material things.” He stabbed a piece of French toast and popped it in his mouth. “Heck of a deal!” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was just starting to feel comfortable with Dr. Harding when, in mid-August, it was time to switch services.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd15b936","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429903073_ch03.vue
// module id = 84
// module chunks = 0